import React from 'react';
import { ArrowRight } from '../icons';

const CTA = ({ t, setPage }) => (
  /* full-width navy bg */
  <div className="w-full bg-navy text-white">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] min-h-[320px] py-16 box-border flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16">
      {/* Text block */}
      <div className="flex flex-col gap-[18px] max-w-[800px]">
        <h2 className="m-0 font-heading font-medium text-[38px] md:text-[48px] leading-[1.1] tracking-[-0.01em] uppercase">
          {t.ctaTitle}
        </h2>
        <p className="m-0 text-[17px] md:text-[18px] text-white/90">{t.ctaSub}</p>
      </div>

      {/* Button */}
      <button
        type="button"
        onClick={() => {
          if (setPage) setPage('contact');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        className="btn shrink-0 flex items-center gap-3 h-14 px-[34px] rounded-[3px] bg-gold text-navy-deep text-[13px] font-bold tracking-widest uppercase cursor-pointer hover:brightness-110 hover:shadow-lg transition-all border-0"
      >
        {t.enquireNow} <ArrowRight size={18} />
      </button>
    </div>
  </div>
);

export default CTA;
